import { css } from 'styled-components';
import makeThemedComponent from '../../utils/makeThemedComponent';
var defaultStyles = css(["border-color:#000;border-style:solid;padding:1rem;"]);
/**
 * Renders a `div` element with padding and a border. Commonly used as a
 * container element.
 *
 * @public
 * @author Connor Taylor
 */

var Card = makeThemedComponent({
  themeKey: "Card",
  component: "div",
  defaultStyles: defaultStyles
});
export { defaultStyles };
/** @component */

export default Card;